import { useMutation, useQuery, useQueryClient } from "react-query";
import useApiHelper from "../services/useApiHelper";

export default function useAllMediaAdmin(agencyId) {
  const staleTime = 10000;
  const queryClient = useQueryClient();
  const { get, post, put, del } = useApiHelper();

  const media = useQuery(
    ["allMedia", agencyId],
    () => get(`/media/all/${agencyId}`).then((res) => res.data),
    {
      staleTime: staleTime,
    }
  );

  return {
    media,
  };
}
